import { useState } from 'react';
import styles from './VideoComponent.module.scss';

export default function VideoComponent({ fields }) {
  const [isPlaying, setIsPlaying] = useState(false);

  const toggleVideoPlay = () => {
    setIsPlaying((prev) => !prev);
  };

  const getVideoUrl = (videoData) => {
    if (videoData && videoData.value) {
      return videoData.value.src || videoData.value.href || videoData.value.url || '';
    }
    if (videoData && videoData.fields) {
      return videoData.fields.src?.value || videoData.fields.url?.value || '';
    }
    return videoData?.value?.src || videoData?.url || '';
  };

  const videoUrl = getVideoUrl(fields?.video);

  // 添加调试信息

  if (!videoUrl) {
    return null;
  }

  return (
    <div className="container">
      <div className={styles.video} data-styles={JSON.stringify(styles)}>
        <div className={styles.video_wrapper} data-aos="fade-up">
          <video
            className={styles.video_container}
            src={videoUrl}
            muted
            playsInline
            autoPlay
            style={{ borderRadius: '20px', width: '100%', height: '100%', objectFit: 'cover' }}
            onEnded={toggleVideoPlay}
          />
        </div>
      </div>
    </div>
  );
}
